import React from "react";

const BusinessOperationsForm = props => {
  return (
    <div className="details_form info_text">
      Production & logistics has no details of its own. Business interruptions,
      labor shortages, supply chain interruptions, utility failures and data loss
      are recorded as damages to this element in surveys.
    </div>
  );
};

export default BusinessOperationsForm;
